module.exports = __webpack_public_path__ + "img/0fa0d1b.jpg";